import React from 'react';
import PropTypes from 'prop-types';
import reactCSS from 'reactcss';

const ColorSwatch = ({ value }) => {
  const styles = reactCSS({
    default: {
      swatch: {
        display: 'inline-block',
        width: '50px',
        height: '22px',
        padding: '2px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'rgb(217, 217, 217)',
        borderRadius: '0px',
        verticalAlign: 'middle'
      },
      color: {
        width: '100%',
        height: '100%',
        borderRadius: '0px',
        background: value
      }
    }
  });

  return (
    <div style={styles.swatch}>
      <div style={styles.color} />
    </div>
  );
};

ColorSwatch.propTypes = {
  value: PropTypes.string.isRequired
};

export default ColorSwatch;
